export default function findIdByPath() {
  const splitPathname = window.location.pathname.split('/');

  if (splitPathname.length > 2) {
    if (splitPathname[1] === 'bok') {
      return splitPathname[2];
    }
  }

  return false;
}



// WEBPACK FOOTER //
// ./src/utils/findIdByPath.js